export const saleTypes = {
    'en': [
        { title: 'Buy', heroTitle: 'Buy', value: 'sale' },
        { title: 'Rent', heroTitle: 'Rent', value: 'rent' }
    ],
    'th': [
        { title: 'ซื้อ', heroTitle: 'ซื้อ', value: 'sale' },
        { title: 'เช่า', heroTitle: 'เช่า', value: 'rent' }
    ],
    'cn': [
        { title: '买房', heroTitle: '买房', value: 'sale' },
        { title: '租房', heroTitle: '租房', value: 'rent' }
    ],
    'ru': [
        { title: 'Купить', heroTitle: 'Купить', value: 'sale' },
        { title: 'Арендовать', heroTitle: 'Арендовать', value: 'rent' }
    ],
    'fr': [
        { title: 'Acheter', heroTitle: 'Acheter', value: 'sale' },
        { title: 'Louer', heroTitle: 'Louer', value: 'rent' }
    ],
    'de': [
        { title: 'Kaufen', heroTitle: 'Kaufen', value: 'sale' },
        { title: 'Mieten', heroTitle: 'Mieten', value: 'rent' }
    ],
    'it': [
        { title: 'Compra', heroTitle: 'Compra', value: 'sale' },
        { title: 'Affitta', heroTitle: 'Affitta', value: 'rent' }
    ],
    'ja': [
        { title: '購入', heroTitle: '購入', value: 'sale' },
        { title: '賃貸', heroTitle: '賃貸', value: 'rent' }
    ],
    'ko': [
        { title: '매매', heroTitle: '매매', value: 'sale' },
        { title: '임대', heroTitle: '임대', value: 'rent' }
    ],
    'es': [
        { title: 'Comprar', heroTitle: 'Comprar', value: 'sale' },
        { title: 'Alquilar', heroTitle: 'Alquilar', value: 'rent' }
    ],
    'tr': [
        { title: 'Satın Al', heroTitle: 'Satın Al', value: 'sale' },
        { title: 'Kirala', heroTitle: 'Kirala', value: 'rent' }
    ],
    'he': [
        { title: 'קנייה', heroTitle: 'קנייה', value: 'sale' },
        { title: 'השכרה', heroTitle: 'השכרה', value: 'rent' }
    ],
    'ar': [
        { title: 'شراء', heroTitle: 'شراء', value: 'sale' },
        { title: 'إيجار', heroTitle: 'إيجار', value: 'rent' }
    ]
};